<template>
  <div class="admin">
    <div class="admin-container">
      <div class="container-header">
        <router-link to="/admin" class="header-title text-green-gradient"
          >ADMIN PANEL</router-link
        >
        <!-- <AdminFilterNavbar /> -->
      </div>
      <div class="container-content">
        <transition name="slide-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AdminFilterNavbar from "@/components/admin/AdminFilterNavbar";

export default {
  name: "Admin",
  metaInfo: {
    title: "Admin - GrowCsn.com",
  },
  components: {
    AdminFilterNavbar,
  },
};
</script>

<style scoped>
.admin {
  width: 100%;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
  padding: 55px 0;
}

.admin .admin-container {
  width: 100%;
  padding: 30px;
  border-radius: 20px;
  background: radial-gradient(120% 140% at 10% 0%, rgb(31 31 36) 0%, rgb(27 27 31) 60%, rgb(24 24 27) 100%);
  border: 2px solid rgb(38 38 43);
  box-shadow: 0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.02);
}

.admin .container-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.admin .container-header a.header-title {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.admin .container-content {
  width: 100%;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid rgb(38 38 43);
}

.admin .container-content .slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.admin .container-content .slide-fade-enter {
  opacity: 0;
}

@media only screen and (max-width: 750px) {
  .admin {
    padding: 55px 10px 45px 10px;
  }

  .admin .admin-container {
    padding: 15px;
    border-radius: 16px;
  }
}

@media only screen and (max-width: 650px) {
  .admin .container-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .admin .container-content {
    margin-top: 10px;
  }
}
</style>
